import { render, staticRenderFns } from "./AddressFormatter.vue?vue&type=template&id=b1187320"
import script from "./AddressFormatter.vue?vue&type=script&lang=js"
export * from "./AddressFormatter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports